export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';

export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';

export const CHECK_USER_SESSION_REQUEST = 'CHECK_USER_SESSION_REQUEST';
export const CHECK_USER_SESSION_SUCCESS = 'CHECK_USER_SESSION_SUCCESS';
export const CHECK_USER_SESSION_FAILURE = 'CHECK_USER_SESSION_FAILURE';

function logInUserRequest() {
  return {
    type: LOGIN_USER_REQUEST,
  };
}

function logInUserFailure(error) {
  return {
    type: LOGIN_USER_FAILURE,
    payload: { error },
  };
}

export function logInUserSuccess(user) {
  return {
    type: LOGIN_USER_SUCCESS,
    payload: { user },
  };
}

export function logInUser(username, password) {
  return dispatch => {
    dispatch(logInUserRequest());

    // Do not use catch, because that will also catch any errors in the dispatch
    // and resulting render, causing an loop of 'Unexpected batch number'
    // errors. See https://github.com/facebook/react/issues/6895
    return fetch('/api/login', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ username, password }),
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        response => {
          if (!response.ok) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }

          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }

          throw new Error('Invalid content type ' +
            response.headers.get('content-type'));
        },
        error => dispatch(logInUserFailure(error))
      )
      .then(
        user => dispatch(logInUserSuccess(user)),
        error => dispatch(logInUserFailure(error))
      );
  };
}

function logOutUserRequest() {
  return {
    type: LOGOUT_USER_REQUEST,
  };
}

function logOutUserFailure(error) {
  return {
    type: LOGOUT_USER_FAILURE,
    payload: { error },
  };
}

export function logOutUserSuccess() {
  return {
    type: LOGOUT_USER_SUCCESS,
  };
}

export function logOutUser() {
  return dispatch => {
    dispatch(logOutUserRequest());

    return fetch('/api/logout', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        () => {
          dispatch(logOutUserSuccess());
        },
        // Do not use catch, because that will also catch
        // any errors in the dispatch and resulting render,
        // causing an loop of 'Unexpected batch number' errors.
        // https://github.com/facebook/react/issues/6895
        error => {
          dispatch(logOutUserFailure(error));
        }
      );
  };
}

function checkUserSessionRequest() {
  return {
    type: CHECK_USER_SESSION_REQUEST,
  };
}

function checkUserSessionSuccess(user) {
  return {
    type: CHECK_USER_SESSION_SUCCESS,
    payload: { user },
  };
}

function checkUserSessionFailure(error) {
  return {
    type: CHECK_USER_SESSION_FAILURE,
    payload: { error },
  };
}

export function checkUserSession() {
  return dispatch => {
    dispatch(checkUserSessionRequest());

    return fetch('/api/users/me', {
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        response => {
          if (!response.ok) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }

          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }

          throw new Error('Invalid content type ' +
            response.headers.get('content-type'));
        },
        error => dispatch(checkUserSessionFailure(error))
      )
      .then(
        user => dispatch(checkUserSessionSuccess(user)),
        error => dispatch(checkUserSessionFailure(error))
      );
  };
}



// WEBPACK FOOTER //
// ./client/src/actions/user.js